import { Dispatch, SetStateAction, useCallback } from 'react';

export const useOnHandleStateChange = (setIsVisiblePassword: Dispatch<SetStateAction<boolean>>) => {
  return useCallback(() => {
    setIsVisiblePassword((prevCheck) => !prevCheck);
  }, []);
};
